import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const ns = 'source-list-page';
export const useSourceListPageTranslation = (): UseTranslationResponse<typeof ns> => (
  useTranslation(ns)
);

export const ruRu = (__LOCALE_RU__ ? ({
  sourceListPage: {
    title: 'Источники',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  sourceListPage: {
    title: 'Sources',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  sourceListPage: {
    title: 'Fuentes',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  sourceListPage: {
    title: 'Fontes',
  },
}) : {}) as Record<string, unknown>;
